import {useRef,useState} from 'react'
import {releasesApi,type ReleasePr} from '@/api/releases'
export function ReleaseReadyControl({pr,owner,refresh}:{pr:ReleasePr;owner:boolean;refresh:()=>Promise<void>}){
 const [busy,setBusy]=useState(false),[message,setMessage]=useState(''),lock=useRef(false)
 if(!pr.draft||pr.state!=='open')return null
 const disabled=!owner||releasesApi.workflowReadOnly
 async function ready(){
  if(disabled||lock.current)return
  lock.current=true;setBusy(true);setMessage('')
  try{const result=await releasesApi.centerAction(pr,'ready','');setMessage(result.message);await refresh()}
  catch(e){setMessage(e instanceof Error?e.message:'לא ניתן לסמן כמוכן. יש לרענן ולנסות שוב.')}
  finally{lock.current=false;setBusy(false)}
 }
 return <div><button disabled={disabled||busy} onClick={()=>void ready()}>{busy?'מסמן כמוכן…':'סמן כמוכן'}</button><p>יש לסמן כמוכן לאחר השלמת בדיקות הסוכן. הפעולה אינה אישור למיזוג.</p>{disabled&&<p>סימון כמוכן זמין לניצן באתר החי בלבד.</p>}{message&&<p role="status">{message}</p>}</div>
}
